"use client";
import { HoverEffect } from "@/components/ui/card-hover-effect";
import SectionHeading from "../../section-heading";

const services = [
  {
    title: "Web Applications",
    description:
      "Responsive, accessible product UIs with React, Next.js, and TypeScript — built for real users and real data.",
    link: "#contact",
  },
  {
    title: "SaaS Dashboards",
    description:
      "Role-based dashboards, analytics, tables, and complex API-driven workflows like GRC and cybersecurity platforms.",
    link: "#contact",
  },
  {
    title: "Performance & UI systems",
    description:
      "Reusable component libraries, lazy loading, code-splitting, and Lighthouse-focused frontend optimization.",
    link: "#contact",
  },
];

const Services = () => {
  return (
    <section id="services" className="relative py-24 px-4">
      <SectionHeading
        eyebrow="[Services]"
        title="How I can"
        highlight="help"
        description="Frontend delivery for SaaS, dashboards, and high-converting product interfaces."
      />
      <div className="max-w-6xl mx-auto">
        <HoverEffect items={services} />
      </div>
    </section>
  );
};

export default Services;
